import React, { useMemo } from 'react';
import dayjs from 'dayjs';

import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import EmailIcon from '@material-ui/icons/Email';
import SmsIcon from '@material-ui/icons/Sms';

import { IAdHocCommunicationHistoryItem } from '../../../lib/types/communication.types';
import { statusTone } from './history-panel.helpers';
import { MethodAvatar } from './history-panel.styles';
import { StatusChip } from '../../_core/_ui/status-chip.styles';

interface IHistoryEventItemProps {
  item: IAdHocCommunicationHistoryItem;
}

export const HistoryEventItem: React.FC<IHistoryEventItemProps> = ({ item }) => {
  const dateLabel = useMemo(() => (
    item.sentAt
      ? `Sent · ${dayjs(item.sentAt).format('MMM D, h:mm A')}`
      : item.scheduledAt
        ? `Scheduled · ${dayjs(item.scheduledAt).format('MMM D, h:mm A')}`
        : '—'
  ), [item.sentAt, item.scheduledAt]);

  const isSms = item.method === 'SMS';

  return (
    <ListItem alignItems="flex-start" divider>
      <ListItemAvatar>
        <MethodAvatar>{isSms ? <SmsIcon fontSize="small" /> : <EmailIcon fontSize="small" />}</MethodAvatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box display="flex" alignItems="center" gridGap={8} flexWrap="wrap">
            <Typography variant="body2" component="span">{item.to}</Typography>
            {item.status && (
              <StatusChip label={item.status} size="small" $tone={statusTone(item.status)} />
            )}
          </Box>
        }
        secondary={
          <Typography variant="caption" color="textSecondary" component="span" display="block">
            {dateLabel}{typeof item.attempts === 'number' && item.attempts > 1 ? ` · ${item.attempts} attempts` : ''}
          </Typography>
        }
      />
    </ListItem>
  );
};
